<ng-container>
    <div class="row bg-white p-0">
        <div class="col-md-12 header"
            style="border-bottom: 1px solid #DFE5ED;display: flex;align-items: baseline;padding: 1em 2em; justify-content: space-between;">
            <span>
                <svg class="pointer" (click)="goToDashboard()" width="34" height="34" viewBox="0 0 34 34" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M17.0465 33C25.8526 33 33.0576 25.8 33.0576 17C33.0576 8.19999 25.8526 1 17.0465 1C8.24039 1 1.0354 8.19999 1.0354 17C1.0354 25.8 8.24039 33 17.0465 33Z"
                        stroke="#DFE5ED" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M15.5828 13.459L12.042 16.9998L15.5828 20.5407" stroke="#272D35" stroke-width="1.09091"
                        stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M21.9586 17H12.1411" stroke="#272D35" stroke-width="1.09091" stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>
            </span>
            <!-- <span>
                <svg class="pointer" width="36" height="36" viewBox="0 0 36 36" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 35C27.35 35 35 27.35 35 18C35 8.65 27.35 1 18 1C8.65 1 1 8.65 1 18C1 27.35 8.65 35 18 35Z"
                        stroke="#DFE5ED" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M14.4609 21.5379L21.5359 14.4629" stroke="#131921" stroke-width="1.5" stroke-linecap="round"
                        stroke-linejoin="round" />
                    <path d="M21.5359 21.5379L14.4609 14.4629" stroke="#131921" stroke-width="1.5" stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>
            </span> -->
        </div>
    </div>
    <div class="row instant-payout-container" *ngIf="contentLoaded">

        <div class="col-xxl-5 col-md-6 col-sm-6 instant-payout-content">    
            <h2 style="font-family: Inter; font-weight: 700; font-size: 24px; color: #04182A; max-width: 520px;">
                Access Your Funds Instantly — Skip the wait
            </h2>
            <p class="heading_description" style="font-family: Inter; font-weight: 400; font-size: 16px; color: #656B73; max-width: 550px;">
                Transfer your available balance now and receive the funds in your linked bank account within 30 minutes—24/7, even on weekends and holidays.                
            </p>    
            <div class="form-section">
                <div>
                    <label for="payoutAmount" class="text__label">Enter Payout Amount</label>
                    <div class="amount-input-wrapper" [ngClass]="{'invalid_input': (errorType !=0)}">
                        <span class="currency-symbol">$</span>
                        <input class="amount_input"  [ngClass]="{'invalid': (errorType !=0)}" type="number" id="payoutAmount" [(ngModel)]="payoutAmount" placeholder="0" (input)="validateAmount($event)" min="0" (keydown)="blockInvalidKeys($event)">
                        <span class="balance-text">Available Balance: <span class="notranslate" style="color: #797F87;font-family: Inter;font-weight: 500;font-size: 12px;">{{instant_payout_config.total_payout | currency : '$'}}</span></span>
                    </div>
                    <p class="mat-error"*ngIf="errorType == 1">
                        Instant payout amount must be greater than or equal to $1</p>
                    <p class="mat-error"*ngIf="errorType == 2">
                            Payout amount can't be greater than <span class="notranslate">${{instant_payout_config.daily_single_payout_amount}}</span></p>  
                    <p class="mat-error"*ngIf="errorType == 3">
                        Instant payout amount should not be greater than available balance</p>                
                </div>
                <div class="mt-3">
                    <label class="text__label mb-0">Select Payout Destination</label>
                    <div *ngIf="instant_payout_config.bank_id && instant_payout_config.bank_eligible" class="payout-option mt-1 mb-2" style="cursor: pointer;"  [class.active]="isBankSelected" (click)="selectBank()">
                        <div>
                            <img src="assets/img/png/instant_pay_bank.png" alt="Bank">
                        </div>
                        <div class="d-flex flex-column">
                            <span class="bank_text" style="color: #131921;">***** {{instant_payout_config.bank_account_number}}</span>
                            <span class="bank_text" style="font-size: 10px; color: #656B73;">Bank Account</span>
                        </div>
                        <div class="input" [class.active]="isBankSelected"></div>
                    </div>
                </div>
                <div *ngIf="instantCard && instantCard.last4" class="payout-option mt-1 mb-3" style="cursor: pointer;"  [class.active]="isCardSelected" (click)="selectCard()">
                    <div>
                        <img [src]="getCardBrandImage(instantCard)" alt="Card" style="width: 32px; height: 32px;">
                    </div>
                    <div class="d-flex flex-column">
                        <span class="bank_text" style="color: #131921;">***** {{instantCard.last4}}</span>
                        <span class="bank_text" style="font-size: 10px; color: #656B73;">Debit Card</span>
                    </div>
                    <div class="input" [class.active]="isCardSelected"></div>
                </div>
                <div *ngIf="!instantCard.length && !instantCard.last4" class="addCard-option mb-3 mt-1 pointer" (click)="addInstantPayoutCard()">
                    <img src="assets\img\png\card-billing.png" alt="Card">
                    <span style="font-family: Inter;font-weight: 500;font-size: 14px;color: #131921;">Add Debit Card</span>
                </div>   
            
                <div class="terms-section">
    
                    <div class="custom-checkbox" [class.checked]="terms" (click)="terms = !terms"></div>
                    
                    <div class="terms__label">
                        I’ve read and agree to the 
                        <a class="highlight" target="_blank" [routerLink]="[(ind_id == 1 || ind_id == 6) ? '/terms/business-owner-med-terms' : '/terms/business-owner-terms']" fragment="instant_payout_terms">Instant Payout Terms & Conditions</a>. 
                        I understand that an early access fee applies and will be deducted from upcoming scheduled payouts.
                    </div>
                
                </div>
                
                <div class="confirm_payout">
                    <button [disabled]="!(this.terms && errorType==0 && (this.isBankSelected || this.isCardSelected))" class="confirm-btn" (click)="makeInstantPayout()">Confirm Payout</button>  
                </div> 
            </div>
        </div>
        
        <div class="col-xxl-7 col-md-6 col-sm-6 instant-payout-video">
            <img [hidden]="showSummary" src="assets/img/gif/payout_illustration_gif.gif" style="height: 264px; width: 289px;"/>
            <div class="payment-summary" *ngIf="showSummary">
                <div class="summary_details">
                    <label style="font-family: Inter; font-weight: 500; font-size: 12px; color: #797F87;">Instant Payout Summary</label>
                    <div class="d-flex mt-3">
                        <div class="bolt_logo">
                            <img src="assets/img/png/Vector.png" style="width: 10px; height: 14px;" />
                        </div>
                        <p class="ms-2" style="font-family: Inter;font-weight: 600;font-size: 16px;color: #131921;">Payout Amount</p>
                    </div>
                    <h2 class="notranslate" style="font-family: Inter;font-weight: 700;font-size: 32px;color: #131921;" *ngIf="payoutAmount > instant_payout_config.total_payout">${{ instant_payout_config.total_payout }}</h2>
                    <h2 class="notranslate" style="font-family: Inter;font-weight: 700;font-size: 32px;color: #131921;" *ngIf="payoutAmount <= instant_payout_config.total_payout">${{ payoutAmount.toFixed(2) }}</h2>
                    <p style="font-family: Inter;font-weight: 500;font-size: 14px;color: #18B557;">Estimated Arrival within ⏰ 30
                        minutes</p>
                </div>
                <div class="px-3" style="height: 160px;">
                        <div class="remaining_balance">
                            <p style="font-family: Inter;font-weight: 400;font-size: 14px;color: #272D35; margin: 0;">Remaining Balance</p>
                            <p class="notranslate" style="font-family: Inter;font-weight: 600;font-size: 14px;color: #131921; margin: 0;" *ngIf="remainingBalance > 0">${{remainingBalance.toFixed(2)}}</p>
                            <p class="notranslate" style="font-family: Inter;font-weight: 600;font-size: 14px;color: #131921; margin: 0;" *ngIf="remainingBalance <= 0">$0</p>

                        </div>
                        <div class="d-flex">
                            <div class="me-2" style="width: 300px;">
                                <p style="font-family: Inter;font-weight: 400;font-size: 14px;color: #272D35; margin-bottom: 2px;"    >Instant Payout Fee ({{instant_payout_config.payout_fee_percentage}}%)
                                </p>
                                <p style="font-family: Inter;font-weight: 400;font-size: 12px;color: #797F87; width: 220px;">The fee will be deducted from your Denefits account balance.</p>
                            </div>
                                <p class="notranslate" style="font-family: Inter;font-weight: 600;font-size: 14px;color: #131921">${{payoutFee.toFixed(2)}}</p>
                        </div>
                </div>
            </div>
        </div>                
    </div>
      
</ng-container>
